/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum CheckupItemsListAliases {
  CHECKUP_ITEM_CARD_CONTAINER = 'checkup-item-card-container',
  CHECKUP_ITEM_CARD_CONTAINER_BODY = 'checkup-item-card-container-body',
  CHECKUP_ITEM_DESCRIPTION_CARD_CONTAINER_ZONE = 'checkup-item-description-card-container-zone',
  CHECKUP_ITEM_INITIAL_DATE_CARD_CONTAINER_ZONE = 'checkup-item-initial-date-card-container-zone',
  CHECKUP_LIST_EXPANDER = 'checkup-list-expander',
  DECK_CHECKUP_LIST = 'deck-checkup-list',
  FETCH_CHECKUP_ITEMS_LIST = 'fetch-checkup-items-list',
  FIELD_CHECKUP_ITEM_DESCRIPTION = 'field-checkup-item-description',
  FIELD_CHECKUP_ITEM_END_DATE = 'field-checkup-item-end-date',
  FIELD_CHECKUP_ITEM_EXPECTED_DATE = 'field-checkup-item-expected-date',
  FIELD_CHECKUP_ITEM_INITIAL_DATE = 'field-checkup-item-initial-date',
  FIELD_CHECKUP_ITEM_PHYSICIAN = 'field-checkup-item-physician',
  FIELD_CHECKUP_ITEM_PHYSICIAN_EXECUTOR = 'field-checkup-item-physician-executor',
  FIELD_CHECKUP_ITEM_STATUS = 'field-checkup-item-status',
  FIELD_CHECKUP_LIST_TITLE = 'field-checkup-list-title',
  LAYOUT_CHECKUP_ITEMS_LIST = 'layout-checkup-items-list',
  MAPPER_CHECKUP_ITEMS_LIST = 'mapper-checkup-items-list',
  PANEL_CHECKUP_ITEMS = 'panel-checkup-items',
  PANEL_EXPANDABLE_CHECKUP_LIST = 'panel-expandable-checkup-list',
  TEXT_CHECKUP_ITEM_DESCRIPTION = 'text-checkup-item-description',
  TEXT_CHECKUP_ITEM_END_DATE = 'text-checkup-item-end-date',
  TEXT_CHECKUP_ITEM_EXPECTED_DATE = 'text-checkup-item-expected-date',
  TEXT_CHECKUP_ITEM_INITIAL_DATE = 'text-checkup-item-initial-date',
  TEXT_CHECKUP_ITEM_PHYSICIAN = 'text-checkup-item-physician',
  TEXT_CHECKUP_ITEM_PHYSICIAN_EXECUTOR = 'text-checkup-item-physician-executor',
  TEXT_CHECKUP_ITEM_STATUS = 'text-checkup-item-status',
  TEXT_CHECKUP_LIST_TITLE = 'text-checkup-list-title',
}
export { CheckupItemsListAliases };
